/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import JsonQuery from 'json-query';
import { hooks as commonHooks, types as commonTypes } from '@sitebuilder/common';
import { Headings } from '../Header/Header';
import HeaderWrapper from '../Header/HeaderWrapper';
import {
    getTextSchemaProperties,
    getStyleSchemaProperties,
    getLayoutSchemaProperties,
} from '../utils';
import ListStyles, { themeListStyles } from './list.style';

export interface ListProperties {
    titles?: Headings[];
    dataKey?: string;
    itemDataKey?: string;
    typographyClass?: string;
}

interface WidgetProperties extends commonTypes.WidgetPropertiesBase, ListProperties {}

interface Widgetprops extends commonTypes.WidgetInstanceProps, ListProperties {}

const List = (props: Widgetprops) => {
    const data: any = props.data;
    const widgetProperties = commonHooks.useWidgetProperties<WidgetProperties>(
        props.widgetInstanceId
    );
    const { styles, titles, dataKey, itemDataKey } = widgetProperties || props;
    const i18n = commonHooks.useLocalization();
    const theme = data?.themeSelected || (props as commonTypes.WidgetInstanceProps).theme;
    const listItems = JsonQuery(`${dataKey}`, { data }).value;
    return (
        <div
            className={`list ${
                widgetProperties?.typographyClass ? widgetProperties.typographyClass : ''
            }`}
            css={css`
                ${!theme ? ListStyles : themeListStyles}
                ${getTextSchemaProperties(
                    widgetProperties,
                    data?.colorSpace
                )}${getStyleSchemaProperties(widgetProperties)}${getLayoutSchemaProperties(
                    widgetProperties
                )}${styles || ''}
            `}
            data-testid="list-item"
        >
            <HeaderWrapper headings={titles} data={data} />
            <ul>
                {listItems?.map((item: string, index: number) => {
                    return (
                        <li className="list-item" key={index}>
                            <div className="list-value">
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: i18n.format(itemDataKey || '', item),
                                    }}
                                />
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default List;
